import { FileUploadState } from './FileUploadState';

export const getNameList = (errors) => {
    if (!errors || errors.length === 0) {
        return null;
    }
    return <gds-list-wrapper type="bullet-list">
        {errors.map(e => <gds-simple-list-item type="bullet-list" key={e.BusinessEmailAddress}>{e.FirstName ?? ""} {e.LastName ?? ""} ({e.BusinessEmailAddress ?? ""})</gds-simple-list-item>)}
    </gds-list-wrapper>;
}

export default ({ agentRosterErrors, setFileUploadState, setSubmissionErrorAlertContent }) => {
    const emailsError = agentRosterErrors.current.find(e => e.duplicateEmails);

    if (emailsError) {
        setSubmissionErrorAlertContent(
            <li className="alert-content">
                <div className="h4">Entries Cannot Have Matching Emails</div>
                {emailsError.duplicateEmails.length === 1 &&
                    <p>The email address {emailsError.duplicateEmails[0]} is assigned to multiple associates. Each email address must be unique.</p>
                }
                {emailsError.duplicateEmails.length > 1 &&
                    <p>The email addresses {emailsError.duplicateEmails.join(", ")} are assigned to multiple associates. Each email address must be unique.</p>
                }
                <gds-list-wrapper type="numbered-list">
                    <gds-simple-list-item type="numbered-list">Delete your file by selecting the trash can icon.</gds-simple-list-item>
                    <gds-simple-list-item type="numbered-list">Update your Agent Roster file to ensure each email address is unique.</gds-simple-list-item>
                    <gds-simple-list-item type="numbered-list">Upload the updated file and resubmit.</gds-simple-list-item>
                </gds-list-wrapper>
            </li>
        );

        setFileUploadState(FileUploadState.SubmissionError);
        return;
    }

    const invalidFileType = agentRosterErrors.current.find(e => e.invalidFileType);

    if (invalidFileType) {
        setSubmissionErrorAlertContent(
            <li className="alert-content">
                <div className="h4">Unsupported File Format</div>
                <p>Files must be in .csv format.</p>
                <gds-list-wrapper type="numbered-list">
                    <gds-simple-list-item type="numbered-list">Delete your file by selecting the trash can icon.</gds-simple-list-item>
                    <gds-simple-list-item type="numbered-list">Make sure your file is saved as a .csv</gds-simple-list-item>
                    <gds-simple-list-item type="numbered-list">Upload the updated file and resubmit.</gds-simple-list-item>
                </gds-list-wrapper>
            </li>
        );

        setFileUploadState(FileUploadState.SubmissionError);
        return;
    }

    const otherErrors = agentRosterErrors.current.filter(e => e.Response?.body?.detail && e.Response.body.detail !== "Val-111");

    if (otherErrors.length > 0) {
        setSubmissionErrorAlertContent(
            <li className="alert-content">
                <div className="h4">Upload failed due to a technical issue</div>
                <p>An error occurred while processing your file. Please try again. If the issue continues, please contact our support team at 1-800-624-2513.</p>
                {getNameList(otherErrors)}
            </li>
        );

        setFileUploadState(FileUploadState.SubmissionError);
        return;
    }

    const duplicateInterview = agentRosterErrors.current.filter(e => e.Response?.body?.detail === "Val-111");

    if (duplicateInterview.length > 0) {
        setSubmissionErrorAlertContent(
            <li className="alert-content">
                <div className="h4">Duplicate users found</div>
                <p>We found users in your file who are either already onboarded or the email address provided is already in use.</p>
                {getNameList(duplicateInterview)}
            </li>
        );

        setFileUploadState(FileUploadState.SubmissionWarning);
        return;
    }

    setFileUploadState(FileUploadState.Complete);

};